var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 7.5,
    stroke: "#CBCBCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3864 26.6149L26.6148 19.3865M16.6749 22.0967L14.8681 23.9034C14.3935 24.3781 14.017 24.9415 13.7602 25.5616C13.5033 26.1818 13.3711 26.8464 13.3711 27.5176C13.3711 28.1888 13.5033 28.8535 13.7602 29.4736C14.017 30.0937 14.3935 30.6572 14.8681 31.1318C15.3428 31.6064 15.9062 31.9829 16.5263 32.2398C17.1465 32.4967 17.8111 32.6289 18.4823 32.6289C19.1536 32.6289 19.8182 32.4967 20.4383 32.2398C21.0584 31.9829 21.6219 31.6064 22.0965 31.1318L23.9008 29.325M22.0953 16.675L23.902 14.8683C24.3767 14.3936 24.9401 14.0171 25.5602 13.7603C26.1804 13.5034 26.845 13.3712 27.5162 13.3712C28.1874 13.3712 28.8521 13.5034 29.4722 13.7603C30.0923 14.0171 30.6558 14.3936 31.1304 14.8683C31.605 15.3429 31.9815 15.9063 32.2384 16.5265C32.4953 17.1466 32.6275 17.8112 32.6275 18.4825C32.6275 19.1537 32.4953 19.8183 32.2384 20.4384C31.9815 21.0586 31.605 21.622 31.1304 22.0967L29.3236 23.9034",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipIcon);
export default __webpack_public_path__ + "static/media/clipIcon.8bd2ea72e13c454e0a24b8f1b090c226.svg";
export { ForwardRef as ReactComponent };